import { type StoreActionApi } from 'react-sweet-state';

import type { ResearchPlan } from './MessageResearch';
import type { ChatMessageResearchStore } from './types';

type ClearResearchPlanContentArgs = { messageId: string };

type ChatMessageResearchStoreAction = (api: StoreActionApi<ChatMessageResearchStore>) => void;

/**
 * Clears only the completed response content from each research plan round,
 * preserving the research steps (the "Completed N steps" breakdown).
 * Used when Guard fires RESPONSE_REDACTION so the steps remain visible but the
 * unredacted response text that streamed above the final answer is removed and
 * no longer left in the store (PRGD-488).
 */
export const clearResearchPlanContent: (
	args: ClearResearchPlanContentArgs,
) => ChatMessageResearchStoreAction =
	({ messageId }: { messageId: string }) =>
	({ getState, setState }: StoreActionApi<ChatMessageResearchStore>) => {
		const currentState = getState();
		const message = currentState[messageId];
		if (!message?.researchPlans) {
			return;
		}
		const clearedPlans: { [roundId: number]: ResearchPlan } = {};
		for (const [roundId, plan] of Object.entries(message.researchPlans)) {
			clearedPlans[Number(roundId)] = { ...plan, content: '' };
		}
		setState({
			...currentState,
			[messageId]: {
				...message,
				researchPlans: clearedPlans,
			},
		});
	};
